import { ToolboxActiveTabs } from 'src/app/components/Toolbox/toolbox.config';
import {
  BULK_SET_ACTIVE_TABS,
  RESET_ACTIVE_TABS,
  SET_ACTIVE_LAYER,
  SET_ACTIVE_TAB,
  SET_AVAILABLE_LAYERS,
  SET_MAP_IMAGE_URL,
  SET_MAP_LAST_CENTER,
  SET_MAP_VIEW_STATE,
  SET_MAP_VISUAL_SETTINGS,
  SET_MAP_ZOOM,
  TOGGLE_ACTIVE_TAB,
  TOGGLE_CROP_ACTIVE,
} from 'src/app/redux/redux-types';
import L from 'leaflet';
import { ITileLayer, IWMSLayer } from 'src/configs/layers';
import { MapVisualSettings, TMapMatrix } from 'src/types/components/map.type';
import { TWeaponRange } from 'src/types/mixed.type';
import { MapViewState } from 'src/enums/map.enum';
import { TLayers } from 'src/app/controllers/LayersController/config';

// export const setEditCommandProps = (payload: CommandProps | undefined) => {
//   return {
//     type: SET_EDIT_COMMAND_PROPS,
//     payload,
//   };
// };

// export const setMapMatrix = (payload: TMapMatrix) => {
//   return {
//     type: MAP_MATRIX_IS_SET,
//     payload,
//   };
// };

export const setActiveTabs = (payload: Record<keyof ToolboxActiveTabs, boolean>) => {
  return {
    type: BULK_SET_ACTIVE_TABS,
    payload,
  };
};

export const setActiveTab = (payload: { key: keyof ToolboxActiveTabs; bool: boolean }) => {
  return {
    type: SET_ACTIVE_TAB,
    payload,
  };
};

export const toggleActiveTab = (payload: { key: keyof ToolboxActiveTabs }) => {
  return {
    type: TOGGLE_ACTIVE_TAB,
    payload,
  };
};

export const resetActiveTabs = () => {
  return {
    type: RESET_ACTIVE_TABS,
  };
};

export const setActiveLayer = (payload: string) => {
  return {
    type: SET_ACTIVE_LAYER,
    payload,
  };
};

export const toggleCropActive = (act: boolean) => {
  return {
    type: TOGGLE_CROP_ACTIVE,
    payload: act,
  };
};

export const setCropMapImageUrl = (url: string) => {
  return {
    type: SET_MAP_IMAGE_URL,
    payload: url,
  };
};

export const setMapZoom = (zoomLevel: number) => {
  return {
    type: SET_MAP_ZOOM,
    payload: zoomLevel,
  };
};
export const setMaplastCenter = (coords: L.LatLng) => {
  return {
    type: SET_MAP_LAST_CENTER,
    payload: coords,
  };
};

export const setMapViewState = (payload?: MapViewState) => {
  return {
    type: SET_MAP_VIEW_STATE,
    payload,
  };
};

export const setMapVisualSettings = (payload: MapVisualSettings) => {
  return {
    type: SET_MAP_VISUAL_SETTINGS,
    payload,
  };
};

export const setAvailableLayers = (payload: TLayers) => {
  return {
    type: SET_AVAILABLE_LAYERS,
    payload,
  };
};

// export const setWeaponDisplayRange = (payload: TWeaponRange | undefined) => {
//   return {
//     type: DISPLAY_WEAPON_RANGE,
//     payload,
//   };
// };

// export const editModeAddLayer = (payload: L.Layer) => {
//   return {
//     type: ADD_EDIT_MODE_LAYER,
//     payload,
//   };
// };
